<mat-form-field class="phone-number-input">
  <mat-label class="font-semibold">{{ label() }}</mat-label>
  <ngx-mat-intl-tel-input
    [preferredCountries]="preferredCountries()"
    [onlyCountries]="onlyCountries()"
    [enablePlaceholder]="true"
    [enableSearch]="true"
    [formControl]="control()"
    [required]="required()"
    [searchPlaceholder]="'Rechercher'"
    (ngModelChange)="onModelChanged()"
    class="w-full"
    name="phone"
    describedBy="phoneInput"
    format="national"
  >
  </ngx-mat-intl-tel-input>
  <mat-error>Numéro invalide</mat-error>
</mat-form-field>
